import { palette } from 'assets/styles/colors';
import colors from '../colors';

const defaultTextColor = colors.palette.primary.main;

const toggleButton = {
  MuiToggleButton: {
    styleOverrides: {
      root: {
        boxShadow: `0px 1px 3px rgba(0,0,0,0.15)`,
        padding: '1rem 1.5rem',
        color: defaultTextColor,
        '&.Mui-selected': {
          backgroundColor: 'transparent',
          border: `3px solid ${palette.cactus[500]}`,
          '&:active, &:hover': {
            backgroundColor: 'transparent',
          },
        },
      },
    },
  },
};

export default toggleButton;
